function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { Ellipsis } from '../../../index';
import { Icon, Progress } from 'mkui-fd';
import Animate from 'rc-animate';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { bytesToSize } from '../../utils';
import PreviewModal from '../PreviewModal';
import { OPTION_TYPE } from '../../constant';
var PREVIEW_URL = OPTION_TYPE.PREVIEW_URL,
    URL = OPTION_TYPE.URL,
    TYPE = OPTION_TYPE.TYPE;
var fileType = ['pdf', 'rar', 'xls', 'ppt', 'doc', 'zip'];
export default function UploadList(props) {
  var _useState = useState({
    previewUrl: '',
    modalShow: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      previewModalState = _useState2[0],
      setPreviewModalState = _useState2[1];

  var mode = props.mode,
      dataList = props.dataList,
      prefixCls = props.prefixCls,
      showPreviewIcon = props.showPreviewIcon,
      showDownloadIcon = props.showDownloadIcon,
      onRemove = props.onRemove;

  var renderIcon = function renderIcon(file) {
    if (file.status === 'uploading') {
      return React.createElement("div", {
        className: "".concat(prefixCls, "-thumbnail-file loading")
      }, fileIcon(file, 'loading'));
    }

    return file[PREVIEW_URL] ? React.createElement("div", {
      className: "".concat(prefixCls, "-thumbnail-img")
    }, React.createElement("img", {
      src: file[PREVIEW_URL],
      alt: "\u6682\u65E0\u56FE\u7247"
    })) : React.createElement("div", {
      className: "".concat(prefixCls, "-thumbnail-file")
    }, fileIcon(file));
  };

  var fileIcon = function fileIcon(file, _type) {
    var type = _type;

    if (!type) {
      var index = fileType.findIndex(function (o) {
        return file.name.indexOf(o) !== -1;
      });
      type = index !== -1 ? "".concat(fileType[index], "-file") : 'file';
    }

    return React.createElement(Icon, {
      type: type,
      className: "".concat(prefixCls, "-thumbnail-file-icon")
    });
  };

  var renderProgress = function renderProgress(file) {
    var loadingProgress = 'percent' in file ? React.createElement(Progress, {
      percent: file.percent,
      showInfo: false,
      strokeWidth: 2,
      type: "line"
    }) : null;
    return file.status === 'uploading' ? React.createElement("div", {
      className: "".concat(prefixCls, "-item-progress"),
      key: "progress"
    }, loadingProgress) : null;
  };

  var renderIconGroup = function renderIconGroup(file) {
    return React.createElement("div", {
      className: "".concat(prefixCls, "-icongroup")
    }, showPreviewIcon && file[TYPE] === 'img' && React.createElement(Icon, {
      type: "show",
      className: "".concat(prefixCls, "-icongroup-icon"),
      onClick: function onClick() {
        handlePreview(file[PREVIEW_URL]);
      }
    }), showDownloadIcon && file[URL] && React.createElement("a", {
      href: file[URL],
      download: file.name
    }, React.createElement(Icon, {
      type: "download",
      className: "".concat(prefixCls, "-icongroup-icon")
    })), React.createElement(Icon, {
      type: "trash",
      onClick: function onClick() {
        handleRemove(file);
      },
      className: "".concat(prefixCls, "-icongroup-icon")
    }));
  };

  var handlePreview = function handlePreview(previewUrl) {
    setPreviewModalState({
      modalShow: true,
      previewUrl: previewUrl
    });
  };

  var handleRemove = function handleRemove(file) {
    if (onRemove) {
      onRemove(file);
    }
  };

  var cancelPreview = function cancelPreview() {
    setPreviewModalState(_objectSpread({}, previewModalState, {
      modalShow: false
    }));
  };

  return React.createElement(React.Fragment, null, React.createElement(Animate, {
    transitionName: "fade",
    component: "div",
    className: "".concat(prefixCls, " ").concat(mode)
  }, dataList.map(function (file) {
    var _classNames;

    return React.createElement("div", {
      className: classNames("".concat(prefixCls, "-item"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-upload"), file.status === 'uploading'), _defineProperty(_classNames, "".concat(prefixCls, "-item-error"), file.status === 'error'), _classNames)),
      key: file.uid
    }, React.createElement("div", {
      className: "".concat(prefixCls, "-thumbnail")
    }, renderIcon(file)), React.createElement("div", {
      className: "".concat(prefixCls, "-item-detail")
    }, React.createElement("p", {
      className: "".concat(prefixCls, "-item-detail-filename")
    }, React.createElement(Ellipsis, {
      value: file.name
    })), React.createElement("p", {
      className: "".concat(prefixCls, "-item-detail-filesize")
    }, React.createElement("span", {
      className: "".concat(prefixCls, "-size")
    }, bytesToSize(file.size))), renderIconGroup(file)), React.createElement(Animate, {
      transitionName: "fade",
      component: "div"
    }, renderProgress(file)));
  })), React.createElement(PreviewModal, {
    visible: previewModalState.modalShow,
    previewUrl: previewModalState.previewUrl,
    onCancel: cancelPreview
  }));
}
UploadList.defaultProps = {
  prefixCls: 'mkui-enhanced-upload-uploadlist',
  mode: 'vertical'
};
UploadList.propTypes = {
  mode: PropTypes.string,
  prefixCls: PropTypes.string,
  showPreviewIcon: PropTypes.bool,
  showDownloadIcon: PropTypes.bool,
  dataList: PropTypes.array
};
//# sourceMappingURL=UploadList.js.map
